module.exports = "pegasus_template/assets/graycircle-youtube.gif";